// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebarContainer {
  width: 236px;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/Layout/AppBar/Mobile/mobile.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,YAAA;AACF","sourcesContent":[".sidebarContainer {\n  width: 236px;\n  height: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
